/* From Victory — product page behavior.
   Variant selection (swatches/boxes -> variant resolution, price,
   availability, media, URL), add-to-cart with cart drawer handoff,
   hover zoom origin, mobile sticky bar, size-guide drawer. */

(function () {
  'use strict';

  function moneyFormat(cents) {
    // The server renders authoritative prices; this mirrors them for
    // live updates. Currency symbol comes from the bootstrap price text.
    var probe = document.querySelector('[data-price-wrap] .price__current');
    var sample = probe ? probe.textContent.trim() : '$';
    var symbol = sample.replace(/[\d.,\s]/g, '') || '$';
    return symbol + (cents / 100).toFixed(2);
  }

  function initProduct(root) {
    var form = root.querySelector('[data-product-form], form[action*="/cart/add"]');
    var picker = root.querySelector('[data-variant-picker]');
    var variantInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceWrap = root.querySelector('[data-price-wrap]');
    var errorEl = root.querySelector('[data-form-error]');
    var gallery = root.querySelector('[data-product-gallery]');
    var stickyBar = root.querySelector('[data-sticky-bar]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyAdd = root.querySelector('[data-sticky-add]');

    var strings = window.FV_STRINGS || {};
    var variants = [];
    if (picker) {
      var dataEl = picker.querySelector('[data-variant-data]');
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    /* ---- variant resolution -------------------------------- */

    function selectedOptions() {
      var values = [];
      if (!picker) return values;
      picker.querySelectorAll('.variant-picker__group').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return options.every(function (value, i) {
          return v.options[i] === value;
        });
      });
    }

    function refreshValueStates(options) {
      picker.querySelectorAll('.variant-picker__group').forEach(function (group, optionIndex) {
        group.querySelectorAll('.variant-picker__value').forEach(function (wrap) {
          var input = wrap.querySelector('input');
          var available = variants.some(function (v) {
            return v.available && v.options.every(function (val, i) {
              if (i === optionIndex) return val === input.value;
              return options[i] === null || val === options[i];
            });
          });
          wrap.classList.toggle('is-unavailable', !available);
        });
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
      });
    }

    function scrollToMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var item = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (window.matchMedia('(min-width: 990px)').matches) {
        item.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
      } else {
        gallery.scrollTo({ left: item.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    function applyVariant(variant) {
      var soldOut = strings.soldOut || 'Sold out';
      var addToCart = strings.addToCart || 'Add to cart';
      var unavailable = strings.unavailable || 'Unavailable';

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = unavailable;
        }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addToCart : soldOut;
      }
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (priceWrap) {
        var current = priceWrap.querySelector('.price__current');
        var compare = priceWrap.querySelector('.price__compare');
        if (current) current.textContent = moneyFormat(variant.price);
        if (compare) {
          if (variant.compare_at_price > variant.price) {
            compare.textContent = moneyFormat(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
      }
      if (stickyPrice) stickyPrice.textContent = moneyFormat(variant.price);
      if (variant.featured_media) scrollToMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (picker) {
      picker.addEventListener('change', function (event) {
        if (!event.target.matches('[data-option-value]')) return;
        var options = selectedOptions();
        refreshValueStates(options);
        applyVariant(findVariant(options));
      });
      refreshValueStates(selectedOptions());
    }

    /* ---- quantity ------------------------------------------- */

    var qty = root.querySelector('[data-quantity]');
    if (qty) {
      var qtyInput = qty.querySelector('input');
      qty.addEventListener('click', function (event) {
        if (event.target.closest('[data-quantity-minus]')) {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        } else if (event.target.closest('[data-quantity-plus]')) {
          qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
        }
      });
    }

    /* ---- add to cart -> drawer ------------------------------ */

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    if (form && document.querySelector('[data-cart-drawer]')) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (addButton) addButton.classList.add('is-loading');

        var body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              showError(data.description || data.message || 'Error');
              return;
            }
            if (data.sections && data.sections['cart-drawer']) {
              document.dispatchEvent(new CustomEvent('cart:section-update', {
                detail: { html: data.sections['cart-drawer'], open: true }
              }));
            }
            document.dispatchEvent(new CustomEvent('cart:refresh-count'));
          })
          .catch(function () {
            showError('Error');
          })
          .finally(function () {
            if (addButton) addButton.classList.remove('is-loading');
          });
      });
    }

    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    /* ---- mobile sticky bar visibility ----------------------- */

    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var below = entries[0].boundingClientRect.top < 0;
          stickyBar.hidden = entries[0].isIntersecting || !below;
        },
        { threshold: 0 }
      );
      io.observe(addButton);
    }

    /* ---- hover zoom origin ---------------------------------- */

    root.querySelectorAll('[data-zoomable]').forEach(function (item) {
      item.addEventListener('mousemove', function (event) {
        var rect = item.getBoundingClientRect();
        item.style.setProperty('--zoom-x', ((event.clientX - rect.left) / rect.width) * 100 + '%');
        item.style.setProperty('--zoom-y', ((event.clientY - rect.top) / rect.height) * 100 + '%');
      });
    });

    /* ---- size guide drawer ---------------------------------- */

    var sizeGuide = root.querySelector('[data-size-guide]');
    if (sizeGuide) {
      var lastFocus = null;
      var openBtns = root.querySelectorAll('[data-size-guide-open]');
      function closeGuide() {
        sizeGuide.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }
      openBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          lastFocus = document.activeElement;
          sizeGuide.hidden = false;
          document.body.style.overflow = 'hidden';
          var closeBtn = sizeGuide.querySelector('button[data-size-guide-close]');
          if (closeBtn) closeBtn.focus();
        });
      });
      sizeGuide.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
        el.addEventListener('click', closeGuide);
      });
      sizeGuide.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeGuide();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
